import { SET_BILLING_ITEMS, GET_BILLING_ITEMS } from "+state/actions/index";
import { ManualSponsorshipConfiguration } from "interfaces/PartnersInterface";

interface BillingState {
	manualSponsorshipConfiguration?: ManualSponsorshipConfiguration;
}

const initialState: BillingState = {
	manualSponsorshipConfiguration: undefined
};

const BillingReducer = (state = initialState, action) => {
	if (action.type === SET_BILLING_ITEMS) {
		return {
			...state,
			...action.payload
		};
	} else {
		return state;
	}
};

export default BillingReducer;
